import Vue from 'vue'
import { index, store, show, update, updateCategories as updateCategoriesService, updateMaterials as updateMaterialsService, updateColors as updateColorsService, updatePrice, resetPrices, destroy } from '../../services/products/products'

function formatNumber (value) {
  if (value === null || value === undefined || value === '') return 0
  return parseFloat(String(value).toString().replace(',', '.'))
}

export const products = {
  namespaced: 'products',
  state: {
    data: [],
    pagination: {},
    details: {},
    loading: false,
    error: null
  },

  actions: {

    index ({ commit }, { page = 1, filters = {} }) {
      commit('setLoading', true)
      let urlQuery = `page=${page}`
      if (filters && typeof filters === 'object') {
        Object.entries(filters).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== '') {
            if (Array.isArray(value)) {
              value.forEach(val => {
                urlQuery += `&${key}[]=${encodeURIComponent(val)}`
              })
            } else {
              urlQuery += `&${key}=${encodeURIComponent(value)}`
            }
          }
        })
      }

      index(page, urlQuery)
        .then(response => {
          commit('setData', response.data.data)
          commit('setPagination', {
            current_page: response.data.current_page,
            total: response.data.total,
            per_page: response.data.per_page,
            last_page: response.data.last_page,
            from: response.data.from,
            to: response.data.to
          })
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
        })
    },

    store ({ commit }, data) {
      commit('setLoading', true)

      data.price = formatNumber(data.price)
      data.saleprice = formatNumber(data.saleprice)
      data.price_platform = formatNumber(data.price_platform)

      store(data)
        .then(response => {
          const product = response.data.product
          if (product && typeof product === 'object') {
            commit('setDetails', product)
          }
          commit('setLoading', false)
          Vue.toasted.success('Produto adicionado com sucesso!')
          setTimeout(() => {
            window.location.href = '/products'
          }, 1800)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao atualizar produto!')
        })
    },

    show ({ commit }, id) {
      commit('setLoading', true)
      show(id)
        .then(response => {
          const product = response.data.original.product
          if (product && product.id) {
            commit('setDetails', product)
          }
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response || error.message)
          commit('setLoading', false)
        })
    },

    update ({ state, commit, dispatch }, { id, data }) {
      commit('setLoading', true)
      update(id, data)
        .then(response => {
          commit('setDetails', response.data.product)
          commit('setLoading', false)
          Vue.toasted.success('Produto atualizado com sucesso!')
          dispatch('show', id)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao atualizar produto!')
        })
    },

    updateCategories ({ commit }, { data }) {
      commit('setLoading', true)
      return updateCategoriesService(data)
        .then(response => {
          commit('setLoading', false)
          data.forEach(item => {
            commit('updateProductInList', {
              id: item.product_id,
              company_category_id: item.company_category_id
            })
          })
          Vue.toasted.success('Categorias atualizadas!')
          return response
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao atualizar categorias!')
          throw error
        })
    },

    updateMaterials ({ commit }, { data }) {
      commit('setLoading', true)
      return updateMaterialsService(data)
        .then(response => {
          commit('setLoading', false)
          Vue.toasted.success('Materiais atualizados!')
          return response
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao atualizar material!')
          throw error
        })
    },

    updateColors ({ commit }, { data }) {
      commit('setLoading', true)
      return updateColorsService(data)
        .then(response => {
          commit('setLoading', false)
          Vue.toasted.success('Cor atualizada!')
          return response
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao atualizar cor!')
          throw error
        })
    },

    updatePrice ({ commit, dispatch }, data) {
      commit('setLoading', true)

      return updatePrice(data)
        .then(response => {
          commit('setLoading', false)
          // data.forEach(item => {
          //   dispatch('updateProductInList', {
          //     id: item.prodct_id,
          //     price: item.saleprice
          //   })
          // })
          Vue.toasted.success('Preços atualizadas!')
          dispatch('index', { page: 1, filters: {} })
          return response
        })
        .catch(error => {
          const message = error.response?.data?.message || error.message
          commit('setError', message)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao atualizar!')
          throw error
        })
    },

    resetPrices ({ commit, dispatch }, productIds) {
      commit('setLoading', true)
      console.log('reset - ', productIds)

      return resetPrices(productIds)
        .then(response => {
          commit('setLoading', false)
          Vue.toasted.success('Preços restaurados com sucesso!')
          dispatch('index', { page: 1, filters: {} })
          $('#returnOriginalPrice').modal('hide')
        })
        .catch(error => {
          commit('setLoading', false)
          const message = error.response?.data?.message || error.message
          Vue.toasted.error(`Erro ao restaurar preços: ${message}`)
        })
    },

    destroy ({ commit }, id) {
      commit('setLoading', true)
      destroy(id)
        .then(response => {
          commit('setDetails', response.data)
          commit('setLoading', false)
          Vue.toasted.success('Produto deletado com sucesso!')
          setTimeout(() => {
            window.location.href = '/products'
          }, 1800)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
          Vue.toasted.error('Erro ao deletar produto!')
        })
    },

    searchProductsWithPaginate ({ commit }, { page, search }) {
      index(page, search)
        .then(response => {
          commit('setData', response.data.products)
          commit('setPagination', response.data.pagination)
          commit('setLoading', false)
        })
        .catch(error => {
          commit('setError', error.response)
          commit('setLoading', false)
        })
    },

    updateProductInList (state, updatedProduct) {
      const index = state.data.findIndex(p => p.id === updatedProduct.id)
      if (index !== -1) {
        const product = state.data[index]
        const categoryExists = product.categories.some(cat =>
          cat.id === updatedProduct.company_category_id
        )
        if (!categoryExists) {
          Vue.set(product, 'categories', [
            ...product.categories,
            { id: updatedProduct.company_category_id }
          ])
          Vue.set(state.data, index, product)
        }
      }
    }
  },

  mutations: {
    setData (state, products) {
      state.data = Array.isArray(products) ? products : []
    },
    setPagination (state, paginate) {
      state.pagination = typeof paginate === 'object' ? paginate : {}
    },
    setDetails (state, product) {
      if (product && typeof product === 'object' && product.id) {
        state.details = {
          ...product,
          price: formatNumber(product.price),
          saleprice: formatNumber(product.saleprice),
          price_platform: formatNumber(product.price_platform),
          stock_quantity: formatNumber(product.stock_quantity),
          stock_min: formatNumber(product.stock_min),
          stock_max: formatNumber(product.stock_max),
          stock_waiting: formatNumber(product.stock_waiting)
        }
        const index = state.data.findIndex(p => p.id === product.id)
        if (index !== -1) Vue.set(state.data, index, product)
      } else {
        state.details = {}
      }
    },
    setLoading (state, status) {
      state.loading = typeof status === 'boolean' ? status : false
    },
    setError (state, error) {
      if (error && error.status === 401) {
        localStorage.clear()
        window.location.href = './login'
      } else {
        state.error = error
      }
    }
  },

  getters: {}
}
